var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2213_78846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 15C7.33847 15.0641 10.2603 15.0395 13.3621 14.8715C14.1509 14.8288 14.8005 14.2988 14.8849 13.5134C14.9481 12.9254 14.9999 12.1062 14.9999 10.9999C14.9999 10.1849 14.9718 9.52573 14.9317 9",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5.9506 14.9982 6.89867 14.7504 7.6454 14.0435C9.34427 12.4353 11.5802 10.2329 13.6547 7.9208C14.1823 7.33283 14.2668 6.49873 13.7711 5.88367C13.4001 5.4232 12.8574 4.80737 12.0751 4.02513C11.5245 3.47447 11.0563 3.04251 10.6667 2.70557",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12845 2.63772C1.17117 1.84894 1.70115 1.19934 2.48656 1.11493C3.07455 1.05173 3.89373 1 5 1C6.10623 1 6.92543 1.05173 7.51343 1.11493C8.29883 1.19934 8.82883 1.84894 8.87157 2.63773C9.03953 5.73953 9.01583 8.8779 8.95173 11.2163C8.89333 13.3476 7.1321 15 5 15C2.86789 15 1.10665 13.3476 1.04825 11.2163C0.984174 8.87787 0.960461 5.73953 1.12845 2.63772Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 5.6665H8.66634",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 10.3335H8.66634",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 12.6665H5.33366",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2213_78846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.93ab9213ea4db5f0aa631ff21d62fd58.svg";
export { ForwardRef as ReactComponent };